import React from 'react';
import { Button } from '../ui/Button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/oYpYxSszLsXsm35KitQu5w/heylloyd-image-1770260700217.png';
const CHECKOUT_URL = 'https://argrutinas.com/cart/42963847676113:1';
export function FinalCTA() {
  return <section id="comprar" className="w-full bg-stone-900 text-stone-50 py-20 px-4 text-center" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-24">
          Lo que estás comprando en realidad
        </h2>

        <div className="text-lg md:text-xl text-stone-300 mb-12 space-y-2" data-id="element-25">
          <p data-id="element-26">No es un PDF.</p>
          <p data-id="element-27">Es una manera de que el cuidado no te coma entero/a.</p>
          <p data-id="element-28">Un sistema que sobrevive al cansancio.</p>
          <p className="text-white font-bold pt-4" data-id="element-29">
            Una carpeta que, si mañana no estás, alguien puede abrir y actuar.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-30">
          {/* Product Image */}
          <div className="w-full max-w-xs flex-shrink-0" data-id="element-31">
            <img src={PRODUCT_IMAGE} alt="Cuidador Sin Caos - Kit imprimible" className="w-full h-auto drop-shadow-2xl" data-id="element-32" />
          </div>

          {/* CTA Box */}
          <div id="cta-box" className="bg-stone-800 p-8 md:p-10 rounded-2xl border border-stone-700 w-full max-w-md" data-id="element-33">
            <p className="text-stone-300 mb-6" data-id="element-34">
              Si hoy estás viviendo con esa presión silenciosa de{' '}
              <span className="italic" data-id="element-35">
                "si yo no lo sostengo, se cae todo"
              </span>
              , armá el tablero.
            </p>

            <div className="mb-8" data-id="element-36">
              <span className="text-4xl md:text-5xl font-bold text-white" data-id="element-37">
                $9.300
              </span>
              <span className="text-stone-400 ml-2" data-id="element-38">ARS</span>
              <div className="mt-2" data-id="element-39">
                <span className="inline-block bg-emerald-600/20 text-emerald-400 text-sm font-medium px-3 py-1 rounded-full border border-emerald-600/30" data-id="element-40">
                  Precio con descuento
                </span>
              </div>
            </div>

            <Button size="lg" withIcon href={CHECKOUT_URL} className="w-full bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-xl px-10 py-5 rounded-xl shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/40 transform hover:scale-[1.02] transition-all duration-200" data-id="element-41">
              Obtener Cuidador Sin Caos
            </Button>

            <p className="mt-6 text-sm text-stone-500" data-id="element-42">
              Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </div>
      </div>
    </section>;
}